import "./style.css";

export default function Parcerias({ partners: partnersProp }) {
  const partners = partnersProp || [];

  if (partners.length === 0) return null;

  return (
    <section className="nucleo-parcerias">
      <h2 className="nucleo-parcerias__titulo">Parcerias</h2>
      <div className="nucleo-parcerias__lista">
        {partners.map((partner, i) => {
          const conteudo = partner.logoUrl ? (
            <img src={partner.logoUrl} alt={partner.name} />
          ) : (
            <span>{partner.name}</span>
          );

          return partner.redirectUrl ? (
            <a
              key={i}
              href={partner.redirectUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="nucleo-parcerias__logo"
              aria-label={partner.name}
            >
              {conteudo}
            </a>
          ) : (
            <div key={i} className="nucleo-parcerias__logo">
              {conteudo}
            </div>
          );
        })}
      </div>
    </section>
  );
}
